export const environment = {
  production: true,
  envName: 'prd',
  spa: {
    baseUrl: '/webapps',
    app: {
      cache: '/cache',
      res: '/reservation',
      srv: '/servicing',
      exc: '/exchange',
      cki: '/checkin',
    },
  },
  api: {
    baseUrl: 'https://space.ana.co.jp',
    clientId: '32579a47d11a4d729553b5576d590f82',
    clientSecret: '7f82164CB6934138a56D9e4EcBf1323c',
    app: {
      sysdate: '/all-snj-sysdate/api/v1',
      authorization: '/all-snj-authorization/api/v1',
      initialization: '/all-snj-initialization/api/v1',
      user: '/all-snj-user/api/v1',
      amcmember: '',
      search: '/all-snj-search/api/v1',
      reservation: '/all-snj-reservation/api/v1',
      servicing: '/all-snj-servicing/api/v1',
      exchange: '/all-snj-exchange/api/v1',
      checkin: '/all-snj-checkin/api/v1',
      member: '/all-snj-member/api/v1',
      credit: '/all-snj-credit/api/v1',
    },
  },
  datadog: {
    disable: false,
    env: 'prd',
    clientToken: 'pub71ef99b3ce6dfa6584aae68f6452919e',
    versionFileRelativeUrl: '',
  },
  tealium: {
    disable: true,
    url: '',
  },
  dynatrace: {
    res: {
      disable: false,
      url: 'https://js-cdn.dynatrace.com/jstag/161f5a57e21/bf90419wvr/f33a70176ad9adae_complete.js',
    },
    srv: {
      disable: false,
      url: 'https://js-cdn.dynatrace.com/jstag/161f5a57e21/bf90419wvr/8e9270c016d27424_complete.js',
    },
    exc: {
      disable: false,
      url: 'https://js-cdn.dynatrace.com/jstag/161f5a57e21/bf90419wvr/87bffb209697bab2_complete.js',
    },
    cki: {
      disable: false,
      url: 'https://js-cdn.dynatrace.com/jstag/161f5a57e21/bf90419wvr/db8a41cb2c7a7b6c_complete.js',
    },
  },
};
